<template>
  <div class="landPlan">

    <div class="edit-area">

      <h2 class="normal">添加规划图</h2>

      <div class="edit-area-content">
        <el-button @click="delAllCells" type="danger">删除此区域及所有地块</el-button>
        <div class="normal">规划区域: <input type="text" v-model="area_name"></div>
        <div class="normal">
          <el-select v-model="area_id" filterable placeholder="所属板块" default-first-option>
            <el-option v-for="item in areaList" :key="item.id" :label="item.area_name + '-' + (item.district || '')" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="normal">
          <el-button @click="seeBackground" type="info">看底图</el-button>
        </div>
        
        <div class="normal">中心点: {{area_center}}</div>
        <div class="normal">左下角: {{southwest}}</div>
        <div class="normal">右上角: {{northeast}}</div>

        <div class="normal">
          <el-button @click="toSelectArea" type="warning">选定此区域</el-button>
        </div>

        <div class="normal">
          <input id="land" type="file" @change="chooseImage">
        </div>
        <div class="normal">
          <el-button @click="upToDb" type="primary">上传</el-button>
        </div>
      </div>

    </div>

    <div id="area_container" :style="mapHeight">
      <el-amap-search-box class="search-box" :search-option="searchOption" :on-search-result="onSearchResult">
      </el-amap-search-box>
      <el-amap class="amap-box" vid="land_map" ref="land_map" :zoom="zoom" :center="center" :amap-manager="amapManager"
        :plugin="plugin" :events="events">
        <el-amap-marker :vid="'land_search_marker' + index" v-for="(marker,index) in markers" :key="index"
          :position="[marker.lng,marker.lat]"></el-amap-marker>
        <!-- <el-amap-marker vid="area_center" :position="area_center.split('|')" icon="./../../static/images/marker1.png" v-if="area_center"></el-amap-marker> -->
      </el-amap>
    </div>

  </div>
</template>

<script>
  import {
    AMapManager
  } from "vue-amap"
  let amapManager = new AMapManager();
  export default {
    data() {
      return {
        id: '',

        mapHeight: {},

        searchOption: {
          city: '杭州',
          citylimit: true
        },
        zoom: 15,
        center: [120.051238, 30.228232],
        amapManager,
        events: {
          'rightclick': (e) => {
            console.log('右点击地图')
            let lnglat = e.lnglat.lng + '|' + e.lnglat.lat;
            this.queryWhichLand(lnglat);
          },
        },
        plugin: [{
          //地图类型，卫星地图和普通地图
          pName: 'MapType',
          defaultType: 0,
        }],
        markers: [],
        area_center: '',
        area_name: '',
        southwest: '',
        northeast: '',

        imageUrl: '',

        imageLayer: null,

        area_id: '',
        areaList: [],

        allPlan: [],
        
        planDB: '',
      }
    },
    created() {
      let height = window.innerHeight + 'px';
      console.log(height)
      this.mapHeight.height = height
    },
    beforeRouteEnter(to, from, next) {
      if(from.name === 'login') {
        to.meta.isBack = true;
      }
      next();
    },
    activated() {
      if(!this.$route.meta.isBack){
        if (this.imageLayer) {
          let currentMap = amapManager.getMap();
          currentMap.remove(this.imageLayer);
        }
        let origin = this.$options.data();
        delete origin.mapHeight;
        delete origin.events;
        Object.assign(this.$data, origin)
        this.init();
      }
      this.$route.meta.isBack=false
    },
    methods: {
      init() {
        let that = this;
        let obj = that.$route.params
        that.center = that.$getMapCenter();
        let city = that.$store.state.Counter.city;
        let planMap = {
          '杭州': 'AreaPlanModel',
          '苏州': 'SzAreaPlanModel',
        }
        that.planDB = planMap[city];
        if (obj.id) {
          that.$axios.get(that.$url_prefix + 'queryOneById', {
            params: {
              id: obj.id,
              db: that.planDB
            }
          }).then(function (res) {
            let plan = res.data.data;
            let currentMap = amapManager.getMap();

            that.imageLayer = new AMap.ImageLayer({
              url: plan.image,
              bounds: new AMap.Bounds(plan.southwest.split('|'), plan.northeast.split('|')),
              zooms: [12, 18],
              opacity: 0.5,
              map: currentMap
            });
            that.imageUrl = plan.image;
            that.id = plan.id;
            that.area_name = plan.name;
            that.center = plan.center.split('|');
            that.area_center = plan.center;
            that.southwest = plan.southwest;
            that.northeast = plan.northeast;
            that.area_id = plan.area_id || '';
          }).catch(function (res) {
            console.log('query fail', res);
            that.$message.error('查询失败, 请检查网络');
          })
        }
        that.$axios.get(that.$url_prefix + 'queryAreaNameList').then((res) => {
          that.areaList = res.data.data;
        }).catch((res) => {
          console.log('fail', res);
        })
      },
      onSearchResult(pois) {
        if (pois.length > 0) {
          let {
            lng,
            lat
          } = pois[0];
          this.markers = pois;
          this.center = [lng, lat];

        }
      },

      toSelectArea() {
        let that = this;
        if (that.southwest) {
          let tip = `确定要更改区域吗？`;
          that.$confirm(tip, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            that.selectArea();
          }).catch(() => {
            console.log('取消')
          });
        } else {
          that.selectArea();
        }
      },
      selectArea() {
        let currentMap = amapManager.getMap();
        let area_center = currentMap.getCenter();
        let bounds = currentMap.getBounds();
        let southwest = bounds.southwest;
        let northeast = bounds.northeast;
        this.area_center = area_center.lng + '|' + area_center.lat;
        this.southwest = southwest.lng + '|' + southwest.lat;
        this.northeast = northeast.lng + '|' + northeast.lat;
      },

      //选择图片
      chooseImage(event) {
        let that = this;
        if (!that.southwest || !that.northeast) {
          that.$message.error('请先确定区域');
          return;
        }
        let option = {
          file: event.target.files[0],
          head_name: 'landPlan',
          limit_size: 'no'
        };
        that.$uploadImage(option).then(function (res) {
          console.log('upload back', res);
          if (!res) {
            console.log('upload fail')
            return;
          }
          that.imageUrl = res;

          let currentMap = amapManager.getMap();
          if (that.imageLayer) {
            currentMap.remove(that.imageLayer);
          }
          that.imageLayer = new AMap.ImageLayer({
            url: res,
            bounds: new AMap.Bounds(that.southwest.split('|'), that.northeast.split('|')),
            zooms: [12, 18],
            opacity: 0.5,
            map: currentMap
          });
        }).catch(function (res) {
          console.log('upload fail', res);
        })
      },

      upToDb() {
        let that = this;
        if (!that.imageUrl) {
          return;
        }
        if (!that.area_name) {
          return;
        }
        if (!that.area_center) {
          return;
        }
        if (!that.southwest) {
          return;
        }
        if (!that.northeast) {
          return;
        }
        let obj = {
          image: that.imageUrl,
          name: that.area_name,
          center: that.area_center,
          southwest: that.southwest,
          northeast: that.northeast
        };
        if (that.area_id) {
          obj.area_id = that.area_id;
        }
        if (that.id) {
          obj.id = that.id;
        }
        let param = {
          'db': that.planDB,
          'model': 'edit',
          'item': JSON.stringify(obj)
        }
        that.$axios.post(that.$url_prefix + 'updateData', param).then(function (res) {
          console.log('发送返回', res)
          that.$router.push({
            path: '/IndexPage'
          })
        }).catch(function (res) {
          console.log('上传失败', res)
        })
      },

      seeBackground() {
        let currentMap = amapManager.getMap();
        if (this.imageLayer) {
          currentMap.remove(this.imageLayer);
          this.imageLayer = null;
        } else {
          if (this.imageUrl) {
            this.imageLayer = new AMap.ImageLayer({
              url: this.imageUrl,
              bounds: new AMap.Bounds(this.southwest.split('|'), this.northeast.split('|')),
              zooms: [12, 18],
              opacity: 0.5,
              map: currentMap
            });
          }
        }
      },

      queryWhichLand(lnglat) {
        let that = this;
        if (that.allPlan.length > 0) {
          that.judgeWhichLand(lnglat);
        } else {
          that.$axios.get(that.$url_prefix + 'getDB', {
            params: {
              dataContent: that.planDB,
              projection: '-_id southwest northeast id'
            }
          }).then(function (res) {
            that.allPlan = res.data.data;
            that.judgeWhichLand(lnglat);
          })
        }
      },
      judgeWhichLand(lnglat) {
        let that = this;
        let list = this.allPlan.filter(x => x.southwest && x.northeast)
        let str = '';
        let arr = [];
        for (let i=0; i<list.length; i++) {
          let bounds = new AMap.Bounds(list[i].southwest.split('|'), list[i].northeast.split('|'));
          if (bounds.contains(lnglat.split('|'))) {
            arr.push(list[i].id);
          }
        }
        if (arr.length === 0) {
          alert("没有匹配的");
        } else {
          that.$axios.post(that.$url_prefix + 'judgeWhichLand', {
            ids: arr,
            lnglat: lnglat
          }).then(function (res) {
            alert(res.data.data);
          })
        }
        
      },

      delAllCells() {
        let that = this;
        if (!that.id) {
          return;
        }
        let tip = `确定要删除此区域所有地块吗？`;
        that.$confirm(tip, '提示', {
          confirmButtonText: '删除',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          that.$axios.get(that.$url_prefix + 'delAllCells', {
            params: {
              id: that.id
            }
          }).then(res => {
            console.log('发送返回', res)
            that.$router.push({
              path: '/IndexPage'
            })
          }).catch(err => {
            console.log('删除失败');
          })
        }).catch(() => {
          console.log('取消删除')
        });
      }

    }
  }

</script>

<style scoped>
  .landPlan {
    display: flex;
    width: 100%;
  }

  .landPlan .edit-area {
    text-align: center;
    width: 30%;
  }

  .landPlan #area_container {
    width: 70%;
    position: fixed;
    top: 0;
    left: 30%;
  }

  #area_container .search-box {
    position: absolute;
    left: 0;
    top: 0;
    border: 1px solid black;
  }

</style>



// WEBPACK FOOTER //
// src/page/LandPlan.vue